import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
import { RouterModule } from '@angular/router';
import {MatTooltip} from '@angular/material/tooltip';
import {HeaderModule} from "../header/header.module";
import {AvatarComponent} from "@shared/components/avatar/avatar.component";



@NgModule({
  declarations: [
    SidebarComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        MatTooltip,
        HeaderModule,
        AvatarComponent
    ],
  exports: [
      SidebarComponent,
    ]
})
export class SidebarModule { }
